import { useState, type FormEvent } from "react";

import { ApiError } from "./api.js";

const MAX_LENGTH = 24;

export function UsernameGate({ onSubmit }: { onSubmit: (username: string) => Promise<void> }) {
  const [username, setUsername] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    if (busy) return;

    setBusy(true);
    setError(null);
    try {
      await onSubmit(username);
    } catch (cause) {
      setError(cause instanceof ApiError ? cause.message : "Couldn't sign in. Try again.");
      setBusy(false);
    }
  }

  return (
    <div className="card card--narrow">
      <h1>Chess</h1>
      <p className="muted">Pick a name to play. No password, no email.</p>

      <form onSubmit={handleSubmit} className="stack">
        <label className="field">
          <span className="field__label">Username</span>
          <input
            value={username}
            onChange={(event) => setUsername(event.target.value)}
            maxLength={MAX_LENGTH}
            placeholder="magnus"
            autoFocus
            autoComplete="off"
            spellCheck={false}
            disabled={busy}
          />
        </label>

        {error ? (
          <p className="error" role="alert">
            {error}
          </p>
        ) : null}

        <button type="submit" disabled={busy || username.trim().length === 0}>
          {busy ? "Signing in…" : "Continue"}
        </button>
      </form>

      <p className="muted footnote">
        Your browser remembers you with a cookie. Clearing it starts a new player.
      </p>
    </div>
  );
}
